const regexes = [
  /^\d+$/, // 只允許數字
  /^.{1,6}$/, // 長度最大為 6
];

const getMessage = '市話分機請填寫正確格式(半形數字，不可有空格)';
const validate = (value) => regexes.every((x) => x.test(value));

/** 自訂驗證市話分機格式 */
export default {
  getMessage,
  validate,
};
